<template>
  <div :class="{formGroup: true, isRequired: itemSetting.action.isRequired}">
    <div class="label" :style="labelStyle">
      <p>{{itemSetting.action.label[lang]}}</p>
      <span v-if="passed !== null && passed === false" class="validateMessage">({{locale.required}})</span>
    </div>
    <div class="signatureBox">
      <!-- <div v-if="dimm" class="dimm" @click="toggleDimm(true)">
        터치하여 서명
      </div> -->
      <div class="signaturePad">
        <VueSignaturePad
          id="signature"
          width="100%"
          height="100%"
          ref="signaturePad"
          :options="options" />
      </div>
      <div class="btns">
        <button type="button" class="btn btnFull btnWhite btnUndo" :class="{active: value !== ''}" @click="undo"></button>
        <button type="button" class="btn btnFull btnWhite btnClear" :class="{active: value !== ''}" @click="clear"></button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'Signaturepad',
  props: [
    'id',
    'itemSetting',
    'lang',
    'locale',
    'storageData',
    'getSubmitData'
  ],
  computed: {
    labelStyle () {
      const fontSize = this.itemSetting.action.labelFontSize
      return {
        ...fontSize && fontSize !== 'default' && {
          fontSize: `${fontSize}px`
        }
      }
    },
    value () {
      const data = typeof (this.getSubmitData.find(x => x.id === this.id)) === 'undefined' ? '' : this.getSubmitData.find(x => x.id === this.id).value
      return data
    },
    passed () {
      return this.getSubmitData && this.getSubmitData.find(x => x.id === this.id)
        ? this.getSubmitData.find(x => x.id === this.id).passed
        : null
    }
  },
  data () {
    return {
      message: 'is required',
      options: {
        penColor: '#303030',
        onBegin: () => this.mousedown(),
        onEnd: () => this.mouseup()
      },
      dimm: false,
      signatureImg: ''
    }
  },
  methods: {
    toggleDimm (isOpen) {
      this.dimm = !isOpen
    },
    undo () {
      this.$refs.signaturePad.undoSignature()
      this.mouseup()
    },
    clear () {
      this.$refs.signaturePad.clearSignature()
      const signature = {
        id: this.id,
        value: '',
        passed: false
      }
      this.$emit('setValue', signature)
    },
    mousedown () {
      document.body.classList.add('layerOn')
    },
    mouseup () {
      const { isEmpty, data } = this.$refs.signaturePad.saveSignature()
      const signature = {
        id: this.id,
        value: data || '',
        passed: !isEmpty
      }
      document.body.classList.remove('layerOn')
      this.$emit('setValue', signature)
    },
    save () {
      const { isEmpty, data } = this.$refs.signaturePad.saveSignature()
      if (isEmpty) {
        alert('서명을 해주세요.')
      } else {
        const signature = {
          id: this.id,
          value: data,
          passed: true
        }
        this.$emit('setValue', signature)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.signatureBox {
  position: relative;
  .btns {
    display: flex;
    margin-top: -1px;
    .btn {
      flex: 1;
      padding-top: 4px;
      padding-bottom: 4px;
      border-color: $color-lgrey;
      background-color: rgba($color-lgrey2, 0.3);
      & + .btn {
        border-left: none;
      }
      &:before {
        content: "";
        display: block;
        height: 24px;
        background: url('~@/assets/img/ico_clear.png') 50% 50% / contain no-repeat;
        opacity: 0.3;
      }
      &.active {
        background-color: $color-white;
        &:before {
          opacity: 0.6;
        }
      }
      &.btnUndo:before {
        background-image: url('~@/assets/img/ico_undo.png');
      }
      &.btnClear:before {
        background-image: url('~@/assets/img/ico_clear.png');
      }
    }
  }
}
</style>
